<template>
  <v-container fluid grid-list-md>
    <v-layout column wrap>
      <v-flex>
        <h1 class="display-3">{{ titulo }} presupuesto</h1>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <form data-vv-scope="form-presup" @submit.prevent="save()" ref="formPresup">
          <v-card>
            <v-card-title primary-title>
              <h3 class="display-1">Datos del Cliente</h3>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-text-field prepend-icon="fa-id-card" v-model="u.cuit" label="CUIT" mask="##-########-#"
                    hint="Ingrese el cuit del cliente para realizar la búsqueda" persistent-hint
                    :loading="loadingCliente" @blur="clienteDatos()" :error-messages="errores.collect('cuit')"
                    v-validate="'required'" data-vv-name="cuit" data-vv-scope="form-presup"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field prepend-icon="person" v-model="u.rzon_soc" label="Razón social" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field prepend-icon="phone" v-model="u.tel" label="Teléfono" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field prepend-icon="email" v-model="u.email" label="E-Mail" readonly></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field prepend-icon="place" v-model="u.dir" label="Dirección" readonly></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn icon @click.native.stop="clienteModalOpen('add')">
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn v-if="u.id" icon @click.native.stop="clienteModalOpen('edit')">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn icon @click.native.stop="clienteBuscarModal = true">
                <v-icon>search</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
          <br>
          <v-card>
            <v-card-title primary-title>
              <h3 class="display-1">Datos del Presupuesto</h3>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-autocomplete prepend-icon="person" :items="vendedores" v-model="f.vendedor_id" label="Vendedor"
                    item-value="id" item-text="name" :error-messages="errores.collect('vendedor_id')"
                    v-validate="'required'" data-vv-name="vendedor_id" data-vv-scope="form-presup"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-autocomplete prepend-icon="person" :items="distribuidores" v-model="f.distribuidor_id"
                    label="Distribuidor" item-value="id" item-text="name"
                    :error-messages="errores.collect('distribuidor_id')" v-validate="" data-vv-name="distribuidor_id"
                    data-vv-scope="form-presup"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-autocomplete prepend-icon="fa-credit-card" :items="condiciones" v-model="f.condicion_pago_id"
                    label="Condición de pago" item-value="id" item-text="desig"
                    :error-messages="errores.collect('condicion_pago_id')" v-validate="'required'"
                    data-vv-name="condicion_pago_id" data-vv-scope="form-presup"></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex x12 sm3>
                  <v-select prepend-icon="fa-truck" :items="fletes" v-model="f.flete_id" label="Flete" item-value="id"
                    item-text="desig" :error-messages="errores.collect('flete_id')" v-validate="'required'"
                    data-vv-name="flete_id" data-vv-scope="form-presup"></v-select>
                </v-flex>
                <v-flex x12 sm2 v-if="f.flete_id === 2">
                  <v-select label="Puerta de salida" v-model="f.puerta_salida"
                    :error-messages="errores.collect('puerta_salida')" v-validate="'required'"
                    data-vv-name="puerta_salida" data-vv-scope="form-presup" :items="puertasSalida" item-value="id"
                    item-text="desig"></v-select>
                </v-flex>
                <!--                                <v-flex x12 sm2 v-if="f.flete_id === 2">-->
                <!--                                    <v-checkbox label="¿Cotizar flete?" v-model="f.flete_cotizar"></v-checkbox>-->
                <!--                                </v-flex>-->

                <v-flex x12 sm2>
                  <v-select label="Provincia" v-model="f.provincia_id" :error-messages="errores.collect('provincia_id')"
                    v-validate="'required'" data-vv-name="provincia_id" data-vv-scope="form-presup" :items="provincias"
                    item-value="id" item-text="desig"></v-select>
                </v-flex>
                <v-flex x12 sm2>
                  <v-select label="Tipo de cliente" v-model="f.cliente_tipo"
                    :error-messages="errores.collect('cliente_tipo')" v-validate="'required'"
                    data-vv-name="cliente_tipo" data-vv-scope="form-presup" :items="clienteTipos" item-value="id"
                    item-text="desig"></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex x12 sm8>
                  <v-text-field prepend-icon="place" v-model="f.dir_entrega" label="Dirección de obra"
                    :error-messages="errores.collect('dir_entrega')" v-validate="'required'" data-vv-name="dir_entrega"
                    data-vv-scope="form-presup" @click.native.stop="mapInit()" :loading="loadingMapa"
                    hint="Dirección de uso final del material" persistent-hint></v-text-field>
                </v-flex>
                <v-flex x12 sm2>
                  <v-text-field prepend-icon="place" v-model="f.lat" label="Latitud"
                    :error-messages="errores.collect('lat')" v-validate="'required'" data-vv-name="lat"
                    data-vv-scope="form-presup"></v-text-field>
                </v-flex>
                <v-flex x12 sm2>
                  <v-text-field prepend-icon="place" v-model="f.lng" label="Longitud"
                    :error-messages="errores.collect('lng')" v-validate="'required'" data-vv-name="lng"
                    data-vv-scope="form-presup"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-tooltip top>
                    <v-select label="Sector económico" slot="activator" v-model="f.sector_economico_id"
                      :items="sectoresEconomicos" item-text="desig" item-value="id"
                      :error-messages="errores.collect('sector_economico_id')" v-validate="'required'"
                      data-vv-name="sector_economico_id" data-vv-scope="form-presup"></v-select>
                    <span>
                      Ejemplo: <br>
                      <b>Sector comercial:</b> shoping, universidad, colegios, comercios, oficinas,etc;<br>
                      <b>Industrial:</b> nave industrial, logística, etc;<br>
                      <b>Residencial:</b> vivienda, edificios, etc;
                    </span>
                  </v-tooltip>
                </v-flex>
                <v-flex x12 sm3>
                  <v-select prepend-icon="attach_money" :items="monedas" v-model="f.moneda_id" label="Moneda"
                    item-value="id" item-text="desig" :error-messages="errores.collect('moneda_id')"
                    v-validate="'required'" data-vv-name="moneda_id" data-vv-scope="form-presup" readonly></v-select>
                </v-flex>
                <v-flex x12 sm3>
                  <v-text-field prepend-icon="attach_money" v-model="f.tipo_cambio"
                    label="Tipo de cambio"></v-text-field>
                </v-flex>
                <v-flex x12 sm3>
                  <v-select :items="alicuotas" v-model="f.alicuota_id" label="Alícuota" item-value="id"
                    item-text="desig" :error-messages="errores.collect('alicuota_id')" v-validate="'required'"
                    data-vv-name="alicuota_id" data-vv-scope="form-presup"></v-select>
                </v-flex>

              </v-layout>
              <v-layout>
                <v-flex>
                  <v-menu ref="menuFecha" :close-on-content-click="false" v-model="menuFecha" :nudge-right="40"
                    :return-value.sync="f.fecha_necesidad" lazy transition="scale-transition" offset-y full-width
                    min-width="290px">
                    <v-text-field slot="activator" v-model="f.fecha_necesidad" label="Fecha de necesidad"
                      prepend-icon="event" readonly persistent-hint clearable
                      hint="Fecha de necesidad declarada por el cliente independientemente de los plazos estandar vigentes o planes de produccion"
                      :error-messages="errores.collect('fecha_necesidad')" v-validate="'required'"
                      data-vv-name="fecha_necesidad" data-vv-scope="form-presup"></v-text-field>
                    <v-date-picker v-model="f.fecha_necesidad" scrollable locale="es-sp">
                      <v-spacer></v-spacer>
                      <v-btn flat color="error" @click="menuFecha = false">Cancelar</v-btn>
                      <v-btn flat color="success" @click="$refs.menuFecha.save(f.fecha_necesidad)">Confirmar</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex>
                  <v-text-field v-model="f.plazo_entrega" label="Plazo de entrega indicado en dias"
                    hint="INCLUIR SOLAMENTE EL NUMERO DE DIAS" :error-messages="errores.collect('plazo_entrega')"
                    v-validate="'required'" data-vv-name="plazo_entrega" data-vv-scope="form-presup"></v-text-field>
                  <!--                                    <v-menu-->
                  <!--                                            ref="menuFechaEntrega"-->
                  <!--                                            :close-on-content-click="false"-->
                  <!--                                            v-model="menuFechaEntrega"-->
                  <!--                                            :nudge-right="40"-->
                  <!--                                            :return-value.sync="f.fecha_entrega"-->
                  <!--                                            lazy-->
                  <!--                                            transition="scale-transition"-->
                  <!--                                            offset-y-->
                  <!--                                            full-width-->
                  <!--                                            min-width="290px"-->
                  <!--                                    >-->
                  <!--                                        <v-text-field-->
                  <!--                                                slot="activator"-->
                  <!--                                                v-model="f.fecha_entrega"-->
                  <!--                                                label="Fecha de Entrega"-->
                  <!--                                                prepend-icon="event"-->
                  <!--                                                readonly-->
                  <!--                                                persistent-hint-->
                  <!--                                                clearable-->
                  <!--                                                hint="Fecha negociada entre la empresa y el cliente"-->
                  <!--                                                :error-messages="errores.collect('fecha_entrega')"-->
                  <!--                                                v-validate="'required'"-->
                  <!--                                                data-vv-name="fecha_entrega"-->
                  <!--                                                data-vv-scope="form-presup"-->
                  <!--                                        ></v-text-field>-->
                  <!--                                        <v-date-picker v-model="f.fecha_entrega" scrollable locale="es-sp">-->
                  <!--                                            <v-spacer></v-spacer>-->
                  <!--                                            <v-btn flat color="error" @click="menuFechaEntrega = false">Cancelar</v-btn>-->
                  <!--                                            <v-btn flat color="success" @click="$refs.menuFechaEntrega.save(f.fecha_entrega)">Confirmar</v-btn>-->
                  <!--                                        </v-date-picker>-->
                  <!--                                    </v-menu>-->
                </v-flex>
              </v-layout>
              <v-flex x12 sm5>
                <p class="subheading">Contacto logístico</p>
                <v-layout row wrap>
                  <v-flex x12 sm3>
                    <v-text-field label="Codigo pais" v-model="telefonoContacto.cod_pais" v-validate="'required'"
                      data-vv-name="cod_pais" data-vv-scope="form-presup" :error-messages="errores.collect('cod_pais')"
                      @input="updateContactoLogistico"></v-text-field>
                  </v-flex>
                  <v-flex x12 sm3>
                    <v-text-field label="Codigo area" v-model="telefonoContacto.cod_area" v-validate="'required'"
                      data-vv-name="cod_area" data-vv-scope="form-presup" :error-messages="errores.collect('cod_area')"
                      @input="updateContactoLogistico"></v-text-field>
                  </v-flex>
                  <v-flex x12 sm3>
                    <v-text-field label="Numero" v-model="telefonoContacto.numero" v-validate="'required'"
                      data-vv-name="numero" data-vv-scope="form-presup" :error-messages="errores.collect('numero')"
                      @input="updateContactoLogistico"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark type="submit" color="green" :loading="loadingAdd">
                <span>guardar</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </v-flex>
    </v-layout>
    <!--CLIENTE BUSQUEDA//////////////////////////////////////////////////////////////////////////////////////////////////-->
    <v-dialog v-model="clienteBuscarModal" scrollable width="400px">
      <v-card>
        <v-toolbar dark dense color="primary">
          <v-toolbar-items>
            <v-text-field solo label="Búsqueda de cliente" prepend-icon="search" v-model="clienteQuery"
              @input="clienteListar"></v-text-field>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="clienteBuscarModal = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-list two-line style="width: 300px">
            <template v-for="(c, index) in clientes">
              <v-list-tile avatar @click.native="clienteActivo = index">
                <v-list-tile-avatar v-if="clienteActivo == index" class="animated fadeIn">
                  <v-icon color="green">check</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="c.rzon_soc"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="c.cuit"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="clienteSel">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--CLIENTE CRUD//////////////////////////////////////////////////////////////////////////////////////////////////-->
    <modal-cliente v-model="clienteAddModal" :datos.sync="u" :oper="clienteOper"
      :cliente="clienteModalId"></modal-cliente>
    <!--MAPA MODAL//////////////////////////////////////////////////////////////////////////////////////////////////-->
    <v-dialog v-model="mapaDialog" scrollable persistent style="z-index:9999;">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Ubique la dirección</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="mapaDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout>
              <v-flex>
                <v-text-field label="Dirección de obra" v-model="f.dir_entrega" prepend-icon="search"
                  @click.stop="predictionModal = true" readonly></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field v-model="f.lat" label="Latitud"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="f.lng" label="Longitud"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field v-model="direccion.calle" label="Calle" @input="updateDireccion"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="direccion.numero" label="Número" @input="updateDireccion"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="direccion.localidad" label="Localidad" @input="updateDireccion"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="direccion.departamento" label="Departamento"
                  @input="updateDireccion"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="direccion.codigoPostal" label="Código Postal"
                  @input="updateDireccion"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="direccion.provincia" label="Provincia" @input="updateDireccion"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="direccion.pais" label="País" @input="updateDireccion"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-progress-linear height="5" :indeterminate="true" :active="loadingGeocode"></v-progress-linear>
                <GmapMap :center="mapCoords" :zoom="mapZoom" map-type-id="terrain" style="width: 100%; height: 300px"
                  @click="mapClick" ref="map">
                  <GmapMarker :position="markerCoords" :clickable="true" @click="mapCoords = markerCoords" />

                </GmapMap>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="green" @click.native="mapaDialog = false" :disabled="!validaDireccion">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="predictionModal" scrollable max-width="600px">
      <v-card>
        <v-toolbar dark>
          <v-text-field hide-details prepend-icon="search" single-line v-model="dirSearch"
            :loading="isLoading"></v-text-field>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="predictionModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-list>
            <template v-for="p in predicciones">
              <v-list-tile @click="setPlace(p)">
                <v-list-tile-title v-html="p.description"></v-list-tile-title>
              </v-list-tile>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import modalCliente from '../../components/ModalCliente';
import { Validator } from 'vee-validate';
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import { gmapApi } from 'vue2-google-maps'
import mixinEmpresa from '../../mixins/empresa'
import mixCliente from '../../mixins/cliente'
import mixUser from '../../mixins/auth/users'
import mixPresup from '../../mixins/presupuesto';

let openexchangeratesToken = '2a26ae842b6d42d4a1995cbfbaa2621b';
const googleApiKey = 'AIzaSyDDUPZqkYwch0pYHORSPyW2WGy3M0rp_gE';
Vue.use(VueGoogleMaps, {
  load: {
    key: googleApiKey,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    language: 'es'
  }
});

function getInitialData() {
  return {
    id: '',
    cliente_id: '',
    vendedor_id: '',
    distribuidor_id: '',
    condicion_pago_id: '',
    flete_id: '',
    logist_contacto: '',
    dir_entrega: '',
    provincia_id: '',
    tipo_cambio: '',
    alicuota_id: '',
    moneda_id: 2,
    lng: '',
    lat: '',
    flete_cotizar: false,
    fecha_necesidad: '',
    fecha_entrega: '',
    plazo_entrega: '',
    sector_economico_id: '',
    puerta_salida: '',
    cliente_tipo: '',
  }
}


export default {
  name: "add",
  $_veeValidate: {
    validator: 'new'
  },
  mixins: [mixinEmpresa, mixCliente, mixUser, mixPresup],
  components: { modalCliente },
  data() {
    return {
      clienteTipos: [
        { id: 'Cliente Particular', desig: 'Cliente Particular' },
        { id: 'Cliente Profesional', desig: 'Cliente Profesional' },
      ],
      menuFecha: false,
      menuFechaEntrega: false,
      loadingMapa: false,
      loadingAdd: false,
      loadingClienteAdd: false,
      loadingCliente: false,
      loadingValCuit: false,
      loadingGeocode: false,
      clienteAddModal: false,
      clienteBuscarModal: false,
      clienteQuery: '',
      clienteActivo: -1,
      clientes: [],
      clienteOper: 'add',
      clienteModalId: '',
      vendedores: [],
      distribuidores: [],
      condiciones: [],
      provincias: [],
      fletes: [],
      monedas: [
        { id: 1, desig: 'PESO' },
        { id: 2, desig: 'DOLAR' },
      ],
      puertasSalida: [
        { id: 1, desig: 'MENDOZA' },
        { id: 2, desig: 'BUENOS AIRES' },
      ],
      alicuotas: [],
      f: getInitialData(),
      u: {
        id: '',
        cuit: '',
        rzon_soc: '',
        email: '',
        dir: '',
        tel: ''
      },
      markerCoords: {
        lat: 0,
        lng: 0
      },
      mapCoords: {
        lat: 0,
        lng: 0
      },
      conocidos: [],
      mapaDialog: false,
      map: {},
      mapZoom: 7,
      marker: {},
      dirSearch: '',
      predicciones: [],
      predictionService: {},
      predictionModal: false,
      dir_entrega: '',
      isLoading: false,
      sectoresEconomicos: [],
      direccion: {
        calle: '',
        numero: '',
        localidad: '',
        provincia: '',
        departamento: '',
        codigoPostal: '',
        pais: ''
      },
      telefonoContacto: {
        cod_pais: '',
        cod_area: '',
        numero: '',
      }
    }
  },
  computed: {
    ...mapState({
      presup: state => state.route.params.presup,
      oper: state => state.route.params.oper,
      id: state => state.route.params.id,
    }),
    titulo() {
      if (this.$route.params.id) {
        return 'Editar';
      } else {
        return 'Agregar';
      }
    },
    validaDireccion() {
      return this.f.dir_entrega && this.f.lat && this.f.lng
        && this.direccion.localidad
        && this.direccion.departamento
        && this.direccion.provincia
        && this.direccion.codigoPostal
        && this.direccion.pais
        && this.direccion.calle
        && this.direccion.numero;
    },
  },
  watch: {
    dirSearch(val) {
      if (!val || val.length < 3) return;
      // Items have already been requested
      if (this.isLoading) return;
      this.isLoading = true;
      this.predictionService.getPlacePredictions(
        {
          input: val,
          componentRestrictions: { country: 'ar' }
        }, (predictions, status) => {
          this.predicciones = predictions;
          this.isLoading = false
        });
    }
  },
  mounted() {
    // Vue.loadScript("https://maps.googleapis.com/maps/api/js?key=" + googleApiKey);
    Validator.extend('validar_cuit', {
      getMessage: () => `El CUIT es inválido`,
      validate: value => new Promise((resolve) => {
        this.loadingValCuit = true;
        this.$http.post('cliente/validar-cuit', { cuit: value })
          .then(r => {
            resolve({ valid: r.data });
            this.loadingValCuit = false;
          })
          .catch(e => {
            resolve({ valid: false });
            this.loadingValCuit = false;
          })
      })
    });
    this.getVendedores(r => {
      this.vendedores = r;
    }, e => {
      console.log(e)
    });
    this.getDistribuidores(r => {
      this.distribuidores = r;
    }, e => {
      console.log(e)
    });
    this.$http.post('condicion-pago/select')
      .then(r => {
        this.condiciones = r.data;
      });
    this.$http.post('flete/select')
      .then(r => {
        this.fletes = r.data;
      });
    this.$http.post('alicuota/select')
      .then(r => {
        this.alicuotas = r.data;
      });
    this.$http.post('provincia/select')
      .then(r => {
        this.provincias = r.data;
      });
    this.$http.post('sector-economico/list')
      .then(r => {
        this.sectoresEconomicos = r.data;
      })
      .catch(err => console.log(err));
    this.consultaCotiz();
    this.traeDatos();
  },
  methods: {
    ...mapActions('notif', ['msjShow']),
    updateContactoLogistico() {
      this.f.logist_contacto = `+${this.telefonoContacto.cod_pais} (${this.telefonoContacto.cod_area}) ${this.telefonoContacto.numero}`;
    },
    traeDatos() {
      if (this.oper !== 'edit') {
        return false;
      }
      this.loading = true;
      this.presupuestoShow(this.id, r => {
        this.f = r.p;
        this.u = r.p.cliente;
        this.loading = false;
      }, err => {
        console.log(err);
        this.loading = false;
      })
    },
    save() {
      this.$validator.validateAll('form-presup')
        .then(r => {
          if (!r) {
            return false;
          }
          this.loadingAdd = true;
          this.f.cliente_id = this.u.id;
          if (this.oper === 'edit') {
            this.presupuestoUpdate(this.f, r => {
              this.msjShow(r);
              for (let key in this.f) {
                this.f[key] = '';
                this.u[key] = '';
              }
              this.$validator.reset();
              setTimeout(() => {
                this.$router.push('/presupuesto/' + r.presu.id);
                this.loadingAdd = false;
              }, 2000)
            }, e => {
              this.msjShow({ tipo: 'error', txt: 'Error de guardado', errores: e.response });
              this.loadingAdd = false;
            })
          } else {
            this.presupuestoStore(this.f, r => {
              this.msjShow(r);
              for (let key in this.f) {
                this.f[key] = '';
                this.u[key] = '';
              }
              this.$validator.reset();
              setTimeout(() => {
                this.$router.push('/presupuesto/' + r.p.id);
                this.loadingAdd = false;
              }, 2000)
            }, e => {
              this.msjShow({ tipo: 'error', txt: 'Error de guardado', errores: e.response });
              this.loadingAdd = false;
            })
          }

        })
    },
    clienteListar() {
      if (!this.clienteQuery || this.clienteQuery.length < 3) {
        return false
      }
      this.clienteBuscar({ q: this.clienteQuery }, r => {
        this.clientes = r;
      }, err => {
        console.log(err)
      })

    },
    clienteDatos() {
      if (!this.u.cuit) {
        return false;
      }
      this.loadingCliente = true;
      this.$http.post('cliente/por-cuit', { cuit: this.u.cuit })
        .then(r => {
          this.u = r.data;
          this.f.cliente_id = this.u.id;
          this.loadingCliente = false;
        })
    },
    clienteSel() {
      Object.assign(this.u, this.clientes[this.clienteActivo]);
      this.f.cliente_id = this.u.id;
      this.clienteBuscarModal = false;
    },
    clienteModalOpen(oper) {
      this.clienteOper = oper;
      this.clienteModalId = this.u.id;
      this.clienteAddModal = true;
    },
    mapInit() {
      this.loadingMapa = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.mapCoords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.markerCoords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.loadingMapa = false;
          this.mapaDialog = true;
        }, err => {
          this.loadingMapa = false;
          this.mapaDialog = true;
        });
      } else {
        this.mapaDialog = true;
      }
      this.$refs.map.$mapPromise.then(() => {
        this.predictionService = new google.maps.places.AutocompleteService();
      })
    },
    mapClick(e) {
      this.markerCoords = e.latLng;
      this.f.lat = e.latLng.lat();
      this.f.lng = e.latLng.lng();
      let geocoder = new google.maps.Geocoder;
      geocoder.geocode({ 'location': e.latLng }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            let r = results[0];
            this.$refs.map.panTo(e.latLng);
            this.f.dir_entrega = r.formatted_address;
            this.setProvincia(r);
            this.setDireccion(r);
          } else {
            window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      });
    },
    setPlace(place) {
      if (!place) return;
      let geocoder = new google.maps.Geocoder;
      geocoder.geocode({ 'placeId': place.place_id }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            let r = results[0];
            this.$refs.map.panTo(r.geometry.location);
            this.mapZoom = 15;
            this.markerCoords = r.geometry.location;
            this.f.lat = this.markerCoords.lat();
            this.f.lng = this.markerCoords.lng();
            this.f.dir_entrega = r.formatted_address;
            this.setProvincia(r);
            this.setDireccion(r);
          } else {
            window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      });
    },
    setProvincia(r) {
      let provTxt = {};
      let provId = '';
      provTxt = r.address_components.find(e => e.types.includes('administrative_area_level_1'));
      provId = this.provincias.find(e => e.desig === provTxt.short_name);
      this.f.provincia_id = (provId) ? provId.id : '';
    },
    setDireccion(r) {
      const find = (type) => {
        const comp = r.address_components.find(e => e.types.includes(type));
        return comp ? comp.long_name : '';
      };
      this.direccion.calle = find('route');
      this.direccion.numero = find('street_number');
      this.direccion.localidad = find('locality');
      this.direccion.departamento = find('administrative_area_level_2');
      this.direccion.provincia = find('administrative_area_level_1');
      this.direccion.codigoPostal = find('postal_code');
      this.direccion.pais = find('country');
    },
    updateDireccion() {
      this.f.dir_entrega = ` ${this.direccion.calle} ${this.direccion.numero} ${this.direccion.localidad} ${this.direccion.departamento} ${this.direccion.provincia} ${this.direccion.codigoPostal} ${this.direccion.pais}`;
    },
    consultaCotiz() {
      // ars
      let instance = axios.create();
      instance.defaults.headers.common = {};
      instance.get('https://openexchangerates.org/api/latest.json?app_id=' + openexchangeratesToken, {
        params: {
          app_id: openexchangeratesToken,
          symbols: 'ARS'
        }
      },
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        })
        .then(r => {
          this.f.tipo_cambio = r.data.rates.ARS;
          console.log(r)
        })
        .catch(err => {
          console.log(err)
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/presup/crud.vue